import { BCDataGrid, BCTreeList } from '@bimser/components';
import { FormItemTypes, MLHelper } from '@bimser/core';
import * as Helpers from '.';
import DataGrid2 from '../..';
import { FormControlsHelpers } from '../../../../../../';
import { IControlProperties } from '../../../../../../entities';
import { IComboBoxProperties } from '../../../ComboBox/entities/IComboBoxProperties';
import { IDataGridColumn } from '../../entities';
import * as Utils from './utils';

export type CustomizedDxColumn = BCDataGrid.Entities.IRemoteColumnProps & {
	retrieveDataGridInstance: () => DataGrid2;
};

export const generateColumns = (
	dataGrid: DataGrid2,
	columns: IDataGridColumn<IControlProperties>[]
) => {
	const isTreeList = dataGrid.controlType === FormItemTypes.EControlTypes.TreeList;
	const Column: any = isTreeList ? BCTreeList.Components.Column : BCDataGrid.Components.Column;

	return columns.map(bcColumn => {
		const dataType = FormControlsHelpers.calculateDataType(
			bcColumn.editType,
			bcColumn.dbType.type
		);

		const dxColumn: CustomizedDxColumn = {
			retrieveDataGridInstance: dataGrid.__retrieveDataGridInstance,
			name: bcColumn.name,
			dataField: bcColumn.name,
			caption: MLHelper.getMLText(bcColumn.caption) || bcColumn.name.toLocaleUpperCase(),
			alignment: bcColumn.align,
			width: bcColumn.width,
			visible: bcColumn.visible,
			dataType,
			allowSorting: FormControlsHelpers.calculateAllowSorting(
				bcColumn.editType,
				bcColumn.formatType.type
			),
			allowHiding: bcColumn.allowHiding,
			allowEditing: FormControlsHelpers.calculateAllowEditing(bcColumn),
			allowExporting: !bcColumn.disableToExport,
			allowSearch: FormControlsHelpers.calculateAllowSearch(
				bcColumn.editType,
				bcColumn.formatType.type
			),
			showEditorAlways: bcColumn.showEditorAlways,
			hidingPriority: bcColumn.hidingPriority,
			dbType: FormControlsHelpers.calculateDBType(bcColumn.dbType.type),
			allowFiltering: FormControlsHelpers.calculateAllowFiltering(
				bcColumn.editType,
				bcColumn.formatType.type
			),
			allowHeaderFiltering: bcColumn.headerFilterEnabled,
			defaultSelectedFilterOperation: Utils.getDefaultOperationByType(dataType),
			setCellValue: Utils.setCellValue
		};

		switch (bcColumn.editType) {
			case 'textBox':
				Helpers.setTextBox(dataGrid, bcColumn, dxColumn);
				break;
			case 'actionButton':
				Helpers.setActionButton(dxColumn);
				break;
			case 'checkBox':
				Helpers.setCheckBox(dxColumn);
				break;
			case 'numberBox':
				Helpers.setNumberBox(bcColumn, dxColumn);
				break;
			case 'multiLanguageTextBox':
				Helpers.setMultiLanguageTextBox(dataGrid, dxColumn);
				break;
			case 'comboBox':
				Helpers.setComboBox(
					dataGrid,
					bcColumn as IDataGridColumn<IComboBoxProperties>,
					dxColumn
				);
				break;
			case 'fileSelect':
				Helpers.setFileSelect(dxColumn);
				break;
			case 'timePicker':
			case 'datePicker':
			case 'dateTimePicker':
				Helpers.setDateTimePicker(dataGrid, dxColumn);
				break;
			case 'dateRangePicker':
				Helpers.setDateRangePicker(dxColumn);
				break;
		}

		if (bcColumn.iconSourceField && bcColumn.iconMatchers.length) {
			dxColumn.cellComponent = Helpers.IconMatcherCellComponent;
		}

		if (dataGrid.contextMenuColumnKey === bcColumn.name) {
			dxColumn.cellComponent = Helpers.ContextMenuCellComponent;
		}

		return (
			<Column
				key={dxColumn.name}
				{...dxColumn}
			>
				{Utils.getChildComponents(dataGrid, bcColumn)}
				{Utils.getValidationComponents(bcColumn)}
			</Column>
		);
	});
};
